;(function() {
  'use strict'

  Controller.$inject = ["datapackService", "glUtils"];
  angular.module('app.core').component('surveyExplorerImportFiltersDialog', {
    controller: Controller,
    templateUrl: 'survey-explorer-import-filters-dialog.html',
    bindings: {
      survey: '<',
      dashboards: '<',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(datapackService, glUtils) {
    var ctrl = this
    var defaultAllKinds = ['COMPLETE', 'EXIT', 'OVERQUOTA']

    ctrl.$onInit = onInit
    ctrl.setDashboard = setDashboard
    ctrl.all = all
    ctrl.none = none
    ctrl.toggleFilter = toggleFilter
    ctrl.isFilterSelected = isFilterSelected
    ctrl.done = done
    ctrl.cancel = cancel

    function onInit() {
      ctrl.dashboardOptions = ctrl.dashboards.map(function(dashboard) {
        return { label: dashboard.name, value: dashboard.id }
      })
      ctrl.dashboardId = null
      ctrl.filters = null
      ctrl.selected = []
      ctrl.anchorIndex = null
    }

    function setDashboard(dashboardId) {
      ctrl.dashboardId = dashboardId
      ctrl.filters = null
      var dashboard = ctrl.dashboards.find(function(dashboard) {
        return dashboard.id === dashboardId
      })
      datapackService
        .getDashboard(ctrl.survey, dashboard.id)
        .then(function(dashboard) {
          ctrl.filters = dashboard.filters.filter(function(filter) {
            return !isDefaultAllFilter(dashboard, filter)
          })
          none()
        })
    }

    function isDefaultAllFilter(dashboard, filter) {
      if (filter.groups.length !== 1) return false

      var group = filter.groups[0]
      if (group.rules.length !== 1) return false

      var rule = group.rules[0]
      if (rule.type !== rule.Types.KIND) return false
      return defaultAllKinds.every(function(kind) {
        return rule.kinds.includes(kind)
      })
    }

    function all() {
      ctrl.selected = ctrl.filters ? ctrl.filters.slice() : []
      ctrl.anchorIndex = null
    }

    function none() {
      ctrl.selected = []
      ctrl.anchorIndex = null
    }

    function toggleFilter(event, filter, index) {
      glUtils.shiftSelect(
        event,
        index,
        ctrl.anchorIndex,
        ctrl.filters,
        isFilterSelected(filter),
        setSelected
      )
      ctrl.anchorIndex = index
    }

    function setSelected(filter, selected) {
      const idx = ctrl.selected.indexOf(filter)
      if (selected && idx === -1) {
        ctrl.selected.push(filter)
      } else if (!selected && idx !== -1) {
        ctrl.selected.splice(idx, 1)
      }
    }

    function isFilterSelected(filter) {
      return ctrl.selected.indexOf(filter) !== -1
    }

    function done() {
      ctrl.onDone({
        $filters: ctrl.selected,
      })
    }

    function cancel() {
      ctrl.onCancel()
    }
  }
})()
